<template>
  <AssessmentRunButtonChapter
    v-for="(category, index) in categoryRoot.children"
    :key="category.id"
    :category="category"
    :index="index"
    :library-book-id="libraryBookId"
    :m-progression-by-chapter="mProgressionByChapter"
  />
</template>
<script lang="ts" setup>
interface Props {
  mProgressionByChapter: Map<
    string,
    { chapterId: string; total: number; count: number }
  >;
}

defineProps({
  mProgressionByChapter: null
});

const { categoryManager, contentMemberId, libraryBookId } =
  inject(INJECT_CATEGORY_PAGE);

const { category: categoryRoot } = categoryManager;

const progressionExercises = useProgressionExercises(
  contentMemberId,
  categoryManager
);

provide(INJECT_PROGRESSION_EXERCISES, progressionExercises);
</script>
